const variationsData = [1, 2, 3, 4]

export default variationsData
